import { useState } from "react";

export const useBillingCycle = () => {
  const [cycle, setCycle] = useState("monthly");
  return { cycle, setCycle };
};
